import {
    Swiper,
    Navigation,
    Autoplay,
    Keyboard,
    // Scrollbar,
} from 'swiper';

Swiper.use([
    Navigation,
    Autoplay,
    Keyboard,
]);

const navigation = (el) => {
    const swiperClass = {
      nextEl: '.' + el + '-swiper__button--next',
      prevEl: '.' + el + '-swiper__button--prev',
    }
    return swiperClass;
}

let aanbod, text, news, media, floorplans, diensten, leesvoer;

$(window).on('load', function () {
    if($('.aanbod-slider').length) {
        aanbod = new Swiper('.aanbod-slider', {
            spaceBetween: 30,
            breakpoints: {
                993: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 1.1,
                },
            },
            navigation: navigation('aanbod-slider'),
            autoplay: {
                delay: 4000,
            },
        });
    }
    if($('.diensten-slider').length) {
        diensten = new Swiper('.diensten-slider', {
            spaceBetween: 30,
            breakpoints: {
                993: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 1.1,
                },
            },
            navigation: navigation('diensten-slider'),
            autoplay: {
                delay: 4000,
            },
        });
    }
    if($('.leesvoer-slider').length) {
        leesvoer = new Swiper('.leesvoer-slider', {
            spaceBetween: 30,
            breakpoints: {
                993: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 1.1,
                },
            },
            navigation: navigation('leesvoer-slider'),
            autoplay: {
                delay: 4000,
            },
        });
    }
    if($('.news-slider').length) {
        aanbod = new Swiper('.news-slider', {
            spaceBetween: 30,
            breakpoints: {
                993: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 1.1,
                },
            },
            navigation: navigation('news-slider'),
            autoplay: {
                delay: 4000,
            },
        });
    }
    if ($('.text__image-swiper').length) {
        text = new Swiper('.text__image-swiper', {
            spaceBetween: 30,
            loop: true,
            observer: true,
            observeParents: true,
            navigation: navigation('text__image'),
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            },
        });
    }
    if ($('.realworks__single__media__swiper').length) {
        media = new Swiper('.realworks__single__media__swiper', {
            spaceBetween: 30,
            loop: true,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.realworks__single__media__swiper__button--next',
                prevEl: '.realworks__single__media__swiper__button--prev',
            },
            keyboard: true,
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            },
        });
    }
    if ($('.realworks__single__floorplans__swiper').length) {
        floorplans = new Swiper('.realworks__single__floorplans__swiper', {
            spaceBetween: 30,
            loop: true,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.realworks__single__floorplans__swiper__button--next',
                prevEl: '.realworks__single__floorplans__swiper__button--prev',
            },
            keyboard: true,
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            },
        });
    }
});

$(window).on('resize', function () {
    if (aanbod) {
        aanbod.update();
    }
    if (news) {
        news.update();
    }
    if (text) {
        text.update();
    }
    if (media) {
        media.update();
    }
    if (floorplans) {
        floorplans.update();
    }
    if (diensten) {
        diensten.update();
    }
    if (leesvoer) {
        leesvoer.update();
    }
});
